import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  openMenu: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() {
  }

  openMobileMenuEvent() {
    this.openMenu.next(!this.openMenu.getValue());
  }
}
